/**
 * An event bus for authentication-related events.
 * Allows subscribing to and emitting events to multiple listeners.
 *
 * @property {Set<Function>} _l - Internal set storing all listener functions.
 *
 * @method on
 * Subscribes a listener function to authentication events.
 * @param {Function} fn - The listener function to be called when an event is emitted.
 * @returns {Function} Unsubscribe function to remove the listener.
 *
 * @method emit
 * Emits an event to all subscribed listeners.
 * @param {*} evt - The event data to be passed to each listener function.
 */
export const authBus = {
  _l: new Set(), // all listeners live here
  on(fn) {
    // subscribe
    this._l.add(fn);
    return () => this._l.delete(fn); // return an unsubscribe function
  },
  emit(evt) {
    // publish
    for (const fn of this._l) fn(evt);
  },
};
